import { setSendMessageSuccess } from './actions';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage } from '../../utils/messageUtils';

export const addTextMessageToChat =
  (text: string, chatId: string, messageId?: string, userId?: number): TThunkAction<void> =>
  (dispatch, getState, context) => {
    const {
      user: { userId: id },
    } = getState();

    const message = createOutcomingMessage({
      text,
      chatId,
      uid: messageId,
      userId: userId !== undefined ? userId : id,
    });

    dispatch(
      setSendMessageSuccess({
        message,
        messageId: messageId || /* istanbul ignore next */ message.messageId,
        messagesMap: context.custom.messagesMap,
      }),
    );
  };
